import { shaderMaterial } from "@react-three/drei";
import { extend, useFrame } from "@react-three/fiber";
import * as THREE from "three";

import fragmentShader from "./energy_frag.glsl";
import vertexShader from "./energy_vert.glsl";
import { useMemo } from "react";

export const EnergyMaterial = shaderMaterial(
  {
    noiseScale: 10,
    speed: 1,
    time: 0,
    packageColor: new THREE.Color("#28c973"),
    stepMin: 0.2,
    stepMax: 0.8,
    glowStrength: 15,
  },
  vertexShader,
  fragmentShader,
);

extend({ EnergyMaterial });

export const useEnergyMaterial = (uniforms = {}) => {
  const energyMaterial = useMemo(() => {
    var mat = new EnergyMaterial(uniforms);
    mat.transparent = true;
    mat.blending = THREE.NormalBlending;
    mat.noiseScale = 1;
    mat.glowStrength = 10;
    mat.depthTest = true;
    mat.side = THREE.FrontSide;
    return mat;
  }, []);

  useFrame(({ clock }) => {
    energyMaterial.time = clock.elapsedTime * 1;
  });

  return energyMaterial;
};
